import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import { InformantNotificationSettings } from './../../overrides/model/InformantNotificationSettings.js';
import { DashboardPreference } from './../../overrides/model/DashboardPreference.js';
import type { Constructor } from '@whispli/types';

export class __Informant extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly email!: string | null;
  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly username!: string | null;
  /**
   * @deprecated For backwards-compatibility only. Use accessCode
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private access_code!: string | null;

  @Expose({groups: ['client']})
  public get accessCode() {
    return this.access_code
  }

  public set accessCode(value) {
    this.access_code = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly timezone!: string;
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly locale!: string;
  /**
   * @deprecated For backwards-compatibility only. Use secondaryLocales
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private secondary_locales!: string;

  @Expose({groups: ['client']})
  public get secondaryLocales() {
    return this.secondary_locales
  }

  public set secondaryLocales(value) {
    this.secondary_locales = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => Boolean)
  public readonly me!: boolean;
  /**
   * @deprecated For backwards-compatibility only. Use isGuest
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private is_guest!: boolean;

  @Expose({groups: ['client']})
  public get isGuest() {
    return this.is_guest
  }

  public set isGuest(value) {
    this.is_guest = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use isDeclarant
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private is_declarant!: boolean;

  @Expose({groups: ['client']})
  public get isDeclarant() {
    return this.is_declarant
  }

  public set isDeclarant(value) {
    this.is_declarant = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use tutorialDismissed
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private tutorial_dismissed!: boolean;

  @Expose({groups: ['client']})
  public get tutorialDismissed() {
    return this.tutorial_dismissed
  }

  public set tutorialDismissed(value) {
    this.tutorial_dismissed = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use appDownloaded
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private app_downloaded!: boolean;

  @Expose({groups: ['client']})
  public get appDownloaded() {
    return this.app_downloaded
  }

  public set appDownloaded(value) {
    this.app_downloaded = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use sendMessageOnEnter
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private send_message_on_enter!: boolean;

  @Expose({groups: ['client']})
  public get sendMessageOnEnter() {
    return this.send_message_on_enter
  }

  public set sendMessageOnEnter(value) {
    this.send_message_on_enter = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use notificationSettings
   */
  @Type(() => InformantNotificationSettings)
  @Expose({groups:["server"]})
  private notification_settings!: InformantNotificationSettings | null;

  @Expose({groups: ['client']})
  public get notificationSettings() {
    return this.notification_settings
  }

  public set notificationSettings(value) {
    this.notification_settings = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use guestConvertedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private guest_converted_at!: string | null;

  @Expose({groups: ['client']})
  public get guestConvertedAt() {
    return this.guest_converted_at
  }

  public set guestConvertedAt(value) {
    this.guest_converted_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use dashboardPreferences
   */
  @Type(() => DashboardPreference)
  @Expose({groups:["server"]})
  private dashboard_preferences?: DashboardPreference | null;

  @Expose({groups: ['client']})
  public get dashboardPreferences() {
    return this.dashboard_preferences
  }

  public set dashboardPreferences(value) {
    this.dashboard_preferences = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private created_at!: string;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private updated_at!: string;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use deletedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private deleted_at!: string | null;

  @Expose({groups: ['client']})
  public get deletedAt() {
    return this.deleted_at
  }

  public set deletedAt(value) {
    this.deleted_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use isArchived
   * @default false
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  @Transform(({ obj }) => !!obj.deleted_at)
  private is_archived!: boolean;

  @Expose({groups: ['client']})
  public get isArchived() {
    return this.is_archived
  }

  public set isArchived(value) {
    this.is_archived = value
  }
}

interface OptionalAlias {
  dashboardPreferences?: import("/builds/whispli/tenant-api-v2/whispli/packages/client/src/tenant/openapi/client/model/DashboardPreference").DashboardPreference | null | undefined;
}
export type Informant = Omit<__Informant, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'access_code' | 'secondary_locales' | 'is_guest' | 'is_declarant' | 'tutorial_dismissed' | 'app_downloaded' | 'send_message_on_enter' | 'notification_settings' | 'guest_converted_at' | 'dashboard_preferences' | 'created_at' | 'updated_at' | 'deleted_at' | 'is_archived' | 'dashboardPreferences'> & OptionalAlias
export const Informant = __Informant as any as Constructor<Informant>
